import { AT } from '../../actions/actionTypes';
import { Language } from './model';
import { StateDefault } from './const';

export default function (state = StateDefault, action: any) {
  switch (action.type) {
    case AT.I18N_SET_LANGUAGE: {
      const language: Language = action.payload;
      return { ...state, lang: language.folder };
    }
    default: {
      return state;
    }
  }
}
